import MessageBox from "sap/m/MessageBox";
import TranslationUtil from "ips/ac/util/TranslationUtil";

export default class HttpUtil {

  public static async get(sUrl: RequestInfo) {
    try {
      const oResponse = await fetch(sUrl, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });
      return this._processResponse(oResponse);
    } catch (e: Error | any) {
      console.error(e);
      throw new Error(e);
    }
  }

  public static async post(sUrl: RequestInfo, oHeadersApi: HeadersInit, oBodyApi: object) {
    try {
      const sBodyJson = oBodyApi ? JSON.stringify(oBodyApi) : null;
      const oHeaders = oHeadersApi ? oHeadersApi : {
        "Content-Type": "application/json", "Accept": "application/json",
      };

      const oResponse = await fetch(sUrl, {
        method: "POST",
        headers: oHeaders,
        body: sBodyJson,
      });
      return this._processResponse(oResponse);
    } catch (e: Error | any) {
      console.error(e);
      throw new Error(e);
    }
  }

  public static async put(sUrl: RequestInfo, oBody: object) {
    try {
      const oResponse = await fetch(sUrl, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(oBody),
      });

      return this._processResponse(oResponse);
    } catch (e: Error | any) {
      console.error(e);
      throw new Error(e);
    }
  }

  public static async patch(sUrl: RequestInfo, oBody: object) {
    try {
      const oResponse = await fetch(sUrl, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(oBody),
      });

      return this._processResponse(oResponse);
    } catch (e: Error | any) {
      console.error(e);
      throw new Error(e);
    }
  }

  public static async delete(sUrl: RequestInfo) {
    return this.deleteBody(sUrl, null);
  }

  public static async deleteBody(sUrl: RequestInfo, oBody: object) {
    try {

      const oResponse = await fetch(sUrl, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(oBody),
      });
      return this._processResponse(oResponse);
    } catch (e: Error | any) {
      console.error(e);
      throw new Error(e);
    }
  }

  private static async _processResponse(oResponse: Response) {
    const sContentType = oResponse.headers.get("content-type");

    if (sContentType && sContentType.includes("application/json")) {
      const oResult = await oResponse.json();

      if (oResponse.ok) {
        return oResult;
      }

      MessageBox.show(TranslationUtil.getText(oResult.message), {
        icon: MessageBox.Icon.ERROR,
        title: TranslationUtil.getText("error"),
        actions: [MessageBox.Action.CLOSE],
      });

      throw new Error(oResult.message);
    } else {
      return await oResponse.text();
    }
  }
}
